import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import FranchisePage from "@/pages/FranchisePage";
import ProgramsPage from "@/pages/ProgramsPage";
import ProgramDetail from "@/pages/ProgramDetail";
import Locations from "@/pages/Locations";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AdminEnquiries from "@/pages/AdminEnquiries";
import MembershipsPlans from "@/pages/MembershipsPlans";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#050505",
              color: "#f7f2e8",
              border: "1px solid rgba(201, 161, 74, 0.4)",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/franchise" element={<FranchisePage />} />
            <Route path="/programs" element={<ProgramsPage />} />
            <Route path="/programs/:slug" element={<ProgramDetail />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin/enquiries" element={<AdminEnquiries />} />
            <Route path="/memberships" element={<MembershipsPlans />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
